import { string } from './type-checkers.js';
const trackList = string
    .type('trackList')
    .group('layout');
export { trackList, };
//# sourceMappingURL=track-list.js.map